import 'reflect-metadata';
import QRCode from 'qrcode';
import { singleton } from 'tsyringe';

@singleton()
export class QRCodeService {
    toDataURL(data: string): Promise<string> {
        return QRCode.toDataURL(data);
    }
}
